import { WEATHER_DATA_FAILURE, WEATHER_DATA_REQUEST, WEATHER_DATA_SUCCESS } from './types/weatherActionTypes';

export function getWeatherDataRequestAction() {
  return {
    type: WEATHER_DATA_REQUEST,
    payload: 'Brussels,be',
  };
}

export function getWeatherDataSuccessAction(payload) {
  return {
    type: WEATHER_DATA_SUCCESS,
    payload,
  };
}

export function getWeatherDataFailureAction(error) {
  return {
    type: WEATHER_DATA_FAILURE,
    payload: error,
    error: true,
  };
}
